var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("sui-message", { attrs: { info: "" } }, [
    _vm.profileType !== 2
      ? _c(
          "p",
          [
            _c("sui-icon", { attrs: { name: "info circle" } }),
            _vm._v(
              " Please promptly notify your Advisor of any material change in life or financial circumstances that may change the investment objectives for managing the Portfolio. "
            ),
          ],
          1
        )
      : _vm.profileType == 2
      ? _c(
          "p",
          [
            _c("sui-icon", { attrs: { name: "info circle" } }),
            _vm._v(
              " Do not use Exhibit B Investor(s) Profile Form if private assets are held. "
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }